import { useDispatch, useSelector } from 'react-redux'
import { IoTrash } from 'react-icons/io5'
import colors from 'tailwindcss/colors'

import { useModal } from '@/hooks/useModal'
import { useToast } from '@/hooks/useToast'
import { api } from '@/services/api'
import { ReduxProps } from '@/storage'
import { MoodsProps, handleSetMoods } from '@/storage/modules/moods/reducer'
import { MoodResponseProps } from '@/types/moodsProps'

import { EmptyState } from '../EmptyState'
import { FormMood } from '../FormMood'

export function Moods() {
  const { openModal } = useModal()
  const { showToast } = useToast()
  const dispatch = useDispatch()

  const { moods } = useSelector<ReduxProps, MoodsProps>((state) => state.moods)

  const handleRemoveMood = async (moodId: string) => {
    try {
      await api.delete(`/moods/${moodId}`)

      const response = await api
        .get('/moods')
        .then((res) => res.data.data as MoodResponseProps[])

      dispatch(handleSetMoods({ moods: response }))

      showToast('Mood removed successfully', {
        type: 'success',
        theme: 'light',
      })
    } catch (error) {
      showToast('Error removing mood', {
        type: 'error',
        theme: 'light',
      })
    }
  }

  return (
    <div>
      {moods.length === 0 && (
        <EmptyState
          title="No moods yet"
          description="Create the first mood to classify tracks in the catalog."
        />
      )}
      {moods.map((mood) => (
        <div key={mood.id} className="relative mt-8">
          <button
            title="Remove"
            className="absolute -right-1.5 -top-1.5 z-10 flex h-8 w-8 items-center justify-center rounded-full border border-red-600 bg-red-600 shadow-sm transition hover:bg-red-700"
            onClick={() => {
              openModal({
                textConfirm: 'Delete',
                description: 'Do you really want to delete the mood?',
                title: 'Attention',
                confirm() {
                  handleRemoveMood(mood.id)
                },
              })
            }}
          >
            <IoTrash size={14} color={colors.white} />
          </button>

          <button
            className="bg-white rounded-2xl p-7 top-5 flex gap-4 justify-between items-center border hover:border-gray-300 w-full text-left"
            onClick={() => {
              openModal({
                small: true,
                children: <FormMood isExist={mood} />,
              })
            }}
          >
            <p className="font-semibold text-gray-500">{mood.title}</p>
          </button>
        </div>
      ))}
    </div>
  )
}
